module.exports = __webpack_public_path__ + "img/tanchuang.346c68f9.png";